import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";

const SidebarClient = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('✅ Utilisateur déconnecté');
      navigate('/');
    } catch (error) {
      console.error('❌ Erreur lors de la déconnexion:', error);
      alert('Erreur lors de la déconnexion');
    }
  };

  return (
    <aside className="bg-darkBlue text-white w-64 h-screen flex flex-col">
      {/* En-tête avec logo */}
      <div className="p-6 border-b border-blue-700">
      <h1 className='texte-white uppercase'> VERYFIT </h1>
      <p className="text-blue-200 text-sm">Espace Client</p>
      </div>

      {/* Navigation principale - Flexible pour prendre l'espace disponible */}
      <nav className="flex-1 p-6">
        <ul className="space-y-3">
          <li>
            <Link 
              to="/client/dashboard" 
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 group"
            >
              <span className="text-lg group-hover:scale-110 transition-transform">🏠</span>
              <span>Tableau de bord</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/client/equipements" 
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 group"
            >
              <span className="text-lg group-hover:scale-110 transition-transform">🚚</span>
              <span>Mes équipements</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/client/rapports" 
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 group"
            >
              <span className="text-lg group-hover:scale-110 transition-transform">📄</span>
              <span>Mes rapports</span>
            </Link>
          </li>
          <li>
            <a 
              href="https://drive.google.com/drive/folders/1I7T4QiutUZEqOhQlmwCpHJvv_PdWw-QC" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 group"
            >
              <span className="text-lg group-hover:scale-110 transition-transform">📖</span>
              <span>Notices d'utilisation</span>
            </a>
          </li>
        </ul>

        {/* Section d'aide */}
        <div className="mt-8 p-4 bg-blue-800 rounded-lg">
          <h4 className="font-semibold text-sm mb-2">💡 Besoin d'aide ?</h4>
          <p className="text-xs text-blue-200 mb-3">
            Contactez votre revendeur FIT pour toute question sur vos équipements.
          </p>
          <a 
            href="mailto:support@fitdoors.com"
            className="text-xs text-blue-300 hover:text-white underline"
          >
            📧 contact@veryfit.fr
          </a>
        </div>
      </nav>
      
      {/* Footer avec bouton déconnexion - Toujours en bas */}
      <div className="p-6 border-t border-blue-700">
        {/* Informations utilisateur */}
        <div className="mb-4 p-3 bg-blue-800 rounded-lg">
          <p className="text-xs text-blue-200 mb-1">Connecté en tant que :</p>
          <p className="text-sm font-medium truncate" title={auth.currentUser?.email}>
            {auth.currentUser?.email}
          </p>
        </div>

        {/* Bouton de déconnexion */}
        <button 
          onClick={handleLogout}
          className="w-full bg-red-600 text-white py-3 px-4 rounded-lg hover:bg-red-700 transition-colors duration-200 flex items-center justify-center gap-2 font-medium"
        >
          <span>🚪</span>
          Se déconnecter
        </button>
      </div>
    </aside>
  );
};

export default SidebarClient;